/**
 * Permission string constants mapped to Django's model permission codenames.
 * Format: <app_label>.view_<model> | add_<model> | change_<model> | delete_<model>
 */

export const PERMISSIONS = {
  // Bookings
  BOOKING_VIEW: "booking.view_booking",
  BOOKING_ADD: "booking.add_booking",
  BOOKING_CHANGE: "booking.change_booking",
  BOOKING_DELETE: "booking.delete_booking",

  // Streams
  STREAM_VIEW: "stream.view_stream",
  STREAM_ADD: "stream.add_stream",
  STREAM_CHANGE: "stream.change_stream",
  STREAM_DELETE: "stream.delete_stream",

  // Venues
  VENUE_VIEW: "venue.view_venue",
  VENUE_ADD: "venue.add_venue",
  VENUE_CHANGE: "venue.change_venue",
  VENUE_DELETE: "venue.delete_venue",

  // Bug Reports
  BUG_VIEW: "bug_report.view_bug",
  BUG_ADD: "bug_report.add_bug",
  BUG_CHANGE: "bug_report.change_bug",
  BUG_DELETE: "bug_report.delete_bug",

  // Call Sheets
  CALLSHEET_VIEW: "call_sheet.view_callsheet",
  CALLSHEET_ADD: "call_sheet.add_callsheet",
  CALLSHEET_CHANGE: "call_sheet.change_callsheet",
  CALLSHEET_DELETE: "call_sheet.delete_callsheet",

  // Configurations - Thumbnails
  THUMBNAIL_VIEW: "configuration.view_thumbnail",
  THUMBNAIL_ADD: "configuration.add_thumbnail",
  THUMBNAIL_CHANGE: "configuration.change_thumbnail",
  THUMBNAIL_DELETE: "configuration.delete_thumbnail",

  // Configurations - general (using thumbnail as a proxy for "can access configurations")
  CONFIGURATION_VIEW: "configuration.view_thumbnail",
  CONFIGURATION_ADD: "configuration.add_thumbnail",
  CONFIGURATION_CHANGE: "configuration.change_thumbnail",
  CONFIGURATION_DELETE: "configuration.delete_thumbnail",

  // Chema (Donations)
  DONATION_VIEW: "chema.view_donation",
  DONATION_ADD: "chema.add_donation",
  DONATION_CHANGE: "chema.change_donation",
  DONATION_DELETE: "chema.delete_donation",
} as const;

export type PermissionKey = keyof typeof PERMISSIONS;
export type PermissionValue = (typeof PERMISSIONS)[PermissionKey];
